// Generated from SVG to Code Figma Plugin

export const BaseLineRecognize = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3 16.5V19.5C3 20.3285 3.67158 21 4.5 21H7.5"
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M16.5 21H19.5C20.3285 21 21 20.3285 21 19.5V16.5"
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M21 7.5V4.5C21 3.67158 20.3285 3 19.5 3H16.5"
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M3 7.5V4.5C3 3.67158 3.67158 3 4.5 3H7.5"
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path d="M12 8.5V16.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round" strokeWidth="1.5" />
    <path d="M8.5 8.5H12H15.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round" strokeWidth="1.5" />
  </svg>
);
